__turbopack_context__.v({
  "active": "TocDiagram-module-scss-module__DdisJa__active",
  "dataPath": "TocDiagram-module-scss-module__DdisJa__dataPath",
  "gap": "TocDiagram-module-scss-module__DdisJa__gap",
  "hover": "TocDiagram-module-scss-module__DdisJa__hover",
  "menuEntry": "TocDiagram-module-scss-module__DdisJa__menuEntry",
  "toc": "TocDiagram-module-scss-module__DdisJa__toc",
  "tocDiagram": "TocDiagram-module-scss-module__DdisJa__tocDiagram",
  "tocGroupTitle": "TocDiagram-module-scss-module__DdisJa__tocGroupTitle",
  "tocTitle": "TocDiagram-module-scss-module__DdisJa__tocTitle",
});
